const courses = [
  {
    "id": 1,
    "code": "BCOM",
    "type":"UG",
    "name": "Bachelor of Commerce",
    "name2" : "Bachelor of Commerce",
    "subjects": {
      "s1": ["Accountancy"],
      "s2": ["Business Studies", "Economics"],
      "s3": ["English", "Maths"]
    }
  },
  {
    "id": 2,
    "code": "MCOM",
    "type":"PG",
    "name": "Master of Commerce",
     "name2" : "Master of Commerce",
    "subjects": {
      "s1": ["Advanced Accountancy"],
      "s2": ["Corporate Law", "Business Economics"],
      "s3": ["Research Methods", "Statistics"]
    }
  },
  {
    "id": 3,
    "code": "BSCBIO",
    "name": "Bachelor of Science (Biology)",
    "type":"UG",
    "name2" : "Bachelor of Science - Biology",
    "subjects": {
      "s1": ["Botany"],
      "s2": ["Zoology"],
      "s3": ["Chemistry", "English"]
    }
  },
  {
    "id": 4,
    "code": "BSCMATH",
    "type":"UG",
     "name2" : "Bachelor of Science - Mathematics",
    "name": "Bachelor of Science (Mathematics)",
    "subjects": {
      "s1": ["Mathematics"],
      "s2": ["Physics"],
      "s3": ["Chemistry", "English"]
    }
  },
  {
    "id": 5,
    "code": "MSCBOT",
    "type":"PG",
     "name2" : "Master of Science - Botany",
    "name": "Master of Science (Botany)",
    "subjects": {
      "s1": ["Plant Physiology"],
      "s2": ["Plant Taxonomy"],
      "s3": ["Plant Genetics", "Ecology"]
    }
  },
  {
    "id": 6,
    "code": "MSCZOO",
    "type":"PG",
     "name2" : "Master of Science - Zoology",
    "name": "Master of Science (Zoology)",
    "subjects": {
      "s1": ["Animal Physiology"],
      "s2": ["Animal Taxonomy"],
      "s3": ["Animal Genetics", "Ecology"]
    }
  },
  {
    "id": 7,
    "code": "MSCCHEM",
    "type":"PG",
     "name2" : "Master of Science - Chemistry",
    "name": "Master of Science (Chemistry)",
    "subjects": {
      "s1": ["Organic Chemistry"],
      "s2": ["Inorganic Chemistry"],
      "s3": ["Physical Chemistry", "Analytical Chemistry"]
    }
  },
  {
    "id": 8,
    "code": "MSCMATH",
    "type":"PG",
     "name2" : "Master of Science - Mathematics",
    "name": "Master of Science (Mathematics)",
    "subjects": {
      "s1": ["Algebra"],
      "s2": ["Analysis"],
      "s3": ["Topology", "Applied Mathematics"]
    }
  },
  {
    "id": 9,
    "type":"PG",
    "code": "MSCPHY",
     "name2" : "Master of Science - Physics",
    "name": "Master of Science (Physics)",
    "subjects": {
      "s1": ["Quantum Mechanics"],
      "s2": ["Electrodynamics"],
      "s3": ["Solid State Physics", "Nuclear Physics"]
    }
  }
];

export default courses;